// Módulos
import { mapGetters } from 'vuex';
import _ from 'lodash';
// Requisições
import { getPendingQuotationsWinners, sendFeedback } from '@/services';
// Components
import FormWinners from '@/components/contractor/quotations-winners/FormWinners.vue';
export default {
    name: 'QuotationsWinners',
    data: () => ({
        alternativeWinners: [
            { name: 'Não houve vencedor', value: 'no-winner' },
            {
                name: 'Fechamos com uma empresa de fora da plataforma',
                value: 'exterior-company'
            },
            {
                name: 'Não faremos a contratação neste momento',
                value: 'not-now'
            }
        ],
        quotations: [],
        feedbacks: [],
        currentQuotationIndex: 0,
        currentSupplierIndex: -1,
        alertModal: false,
        modalMessage: ''
    }),
    components: { FormWinners },
    async created() {
        try {
            let url = '';
            if (this.verifyUserType().isAdmin) {
                url = '?owner=' + this.$route.params.owner;
            }
            const { results } = await getPendingQuotationsWinners(url);
            this.quotations = results;
            const feedbacks = [];
            this.quotations.forEach(() => {
                feedbacks.push({
                    supplier: '',
                    reason: '',
                    message: '',
                    feedbackSent: false,
                    reasonText: '',
                    messageText: '',
                    disableSubmitButton: false
                });
            });
            this.feedbacks = feedbacks;
        } catch (error) {
            console.error(error);
            this.quotations = [];
        }

        const quotationId = parseInt(this.$route.params.id);
        const index = _.findIndex(this.quotations, { id: quotationId });
        if (index) {
            this.currentQuotationIndex = Math.max(0, index);
        }
    },
    methods: {
        ...mapGetters('user', ['verifyUserType']),
        async sendFeedback(quotation) {
            if (this.feedbacks[this.currentQuotationIndex].message === '') {
                this.modalMessage = 'Preencha o formulário antes de enviar o feedback.';
                return (this.alertModal = true);
            } else {
                this.$set(this.feedbacks[this.currentQuotationIndex], 'disableSubmitButton', true);
                try {
                    const nonWinners = _.map(
                        _.filter(
                            quotation.occupations,
                            occupation => occupation.supplier.id !== this.feedbacks[this.currentQuotationIndex].supplier
                        ),
                        occupation => {
                            return occupation.supplier.id;
                        }
                    );
                    const data = {
                        competition: quotation.id,
                        message: this.getMessage(),
                        supplier: this.getWinner(),
                        reason: this.getReason(),
                        suppliers: nonWinners,
                        alternative_winner: this.getAlternativeWinner()
                    };
                    await sendFeedback(data);
                    this.modalMessage = 'Feedback recebido com sucesso.';
                    this.alertModal = true;
                    this.$set(this.feedbacks[this.currentQuotationIndex], 'feedbackSent', true);

                    this.feedbacks = this.feedbacks.filter(element => !element.feedbackSent);
                    if (this.feedbacks.length > 0) {
                        this.quotations.splice(this.currentQuotationIndex, 1);
                        this.currentQuotationIndex = 0;
                    } else {
                        window.location.href = '/cotacoes';
                    }
                } catch (error) {
                    console.error(error);
                    this.$set(this.feedbacks[this.currentQuotationIndex], 'disableSubmitButton', false);
                    this.$set(this.feedbacks[this.currentQuotationIndex], 'feedbackSent', false);
                }
            }
        },
        selectSupplier(value) {
            this.currentSupplierIndex = _.findIndex(this.alternativeWinners, {
                value: value
            });
        },
        getWinner() {
            if (this.currentSupplierIndex === -1) {
                return this.feedbacks[this.currentQuotationIndex].supplier;
            } else {
                return;
            }
        },
        getAlternativeWinner() {
            if (this.currentSupplierIndex !== -1) {
                return _.snakeCase(this.feedbacks[this.currentQuotationIndex].supplier);
            } else {
                return '';
            }
        },
        getReason() {
            const reason = _.find(this.reasons, {
                value: this.feedbacks[this.currentQuotationIndex].reason
            });
            if (!reason) {
                return '';
            } else if (reason.value === 'other') {
                return this.feedbacks[this.currentQuotationIndex].reasonText;
            } else {
                return reason.name;
            }
        },
        getMessage() {
            const message = _.find(this.messages, {
                value: this.feedbacks[this.currentQuotationIndex].message
            });
            if (!message) {
                return '';
            } else if (message && message.value === 'other') {
                return this.feedbacks[this.currentQuotationIndex].messageText;
            } else {
                return message.name;
            }
        }
    }
};
